import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getDocumentListHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "clientdocument", ...action.payload }),
		);
		yield put({
			type: types.GET_DOCUMENT_LIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_DOCUMENT_LIST_ERROR,
			payload,
		});
	}
}

export function* getDocumentListWatcherSaga() {
	yield takeLatest(types.GET_DOCUMENT_LIST_START, getDocumentListHandlerSaga);
}

//create

//delete

function* deleteDocumentListHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("clientdocument", action.payload),
		);
		yield put({
			type: types.DELETE_DOCUMENT_LIST_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_DOCUMENT_LIST_ERROR,
			payload,
		});
	}
}

export function* deleteDocumentListWatcherSaga() {
	yield takeLatest(types.DELETE_DOCUMENT_LIST_START, deleteDocumentListHandlerSaga);
}

//update
